import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import ErrorField from '../../components/ErrorField';
import appLogo from '../../assets/img/camatGo-2022-small.png'
import { SubmitHandler, useForm } from 'react-hook-form';
import { IResetPassword, resetPasseordLink } from '../../api/common-api';
import Loader from '../../components/Loader';
import Helper from '../../utils/Helper';

type Props = {};

const ForgotPassword: React.FC<Props> = () => {
    const [loader, showLoader] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    const {
        register,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm<IResetPassword>({ criteriaMode: "all" });

    useEffect(() => {
        localStorage.clear()
    }, [])

    const onSubmitForm: SubmitHandler<IResetPassword> = async ({ email }) => {
        showLoader(true)

        const res = await resetPasseordLink(email)
        console.log("reqeust password reset link :", res)

        showLoader(false)
        if (res.status === 200) {
            if (res.data.success) {
                setIsSuccess(true)
                reset({ email: '' })
            } else {
                Helper.bulkResponseError(res)
            }
        } else {
            Helper.bulkResponseError(res)
        }
    }


    return (
        <>
            <div className="h-full flex flex-col justify-center items-center space-y-8">

                <LazyLoadImage effect='blur' src={appLogo} className='w-20 h-20 mx-auto' />

                <div className='text-center'>
                    <h1 className="text-2xl md:text-3xl font-extrabold">Forgot your password?</h1>
                    <p className="mt-5">Please enter the email you use to sign in</p>
                </div>


                <form onSubmit={handleSubmit(onSubmitForm)} className="space-y-7 px-3 md:px-0 w-11/12 md:w-7/12">
                    {isSuccess &&
                        <div className='bg-green-100 rounded-lg shadow-md px-5 py-5'>
                            <p>We have e-mailed your password reset link, please check your email to reset your password.</p>
                        </div>
                    }
                    <div>
                        <label className="font-semibold" htmlFor="email-address">Email address</label>
                        <input id="email-address" type="text" autoComplete="email" className="text-input"
                            {...register("email", {
                                required: "Email is required.",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Invalid email address."
                                }
                            })} />
                        <ErrorField errors={errors} name='email' />
                    </div>

                    <button type='submit' className="btn-submit" >
                        Request password reset
                    </button>
                </form>

                <div className='font-medium text-sm flex items-center justify-center'>
                    <Link to='/auth' className='text-primary hover:text-orange-500 ml-1'>Back to Sign in</Link>
                </div>

                <div className='font-medium text-sm flex items-center justify-center text-dark'>
                    © Electronic System Administration Pajak v1.0
                </div>

            </div>

            {loader && <Loader />}
        </>
    );
}

export default ForgotPassword;